import { useState } from "react"
import ScrollBar from "react-perfect-scrollbar"
import { toast } from "react-toastify"
import { Button, Col, Form, Input, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap"
import Select from "../../../../Components/Select/Select"
import apiNode from "../../../../services/ApiNode"
import ErrorToast from "../../../../utility/componentsToast/ErrorToast"
import { maskTelefone, numberIsValid } from "../../../../utility/Utils"
import '../CalculadoraMva.scss'
import Cookies from 'universal-cookie'
export default function ModalCadastroReev(props) {
  const cargos = [
    { id: 0, name: "Escolha o seu cargo" },
    { id: 1, name: "Analista" },
    { id: 2, name: "Assistente" },
    { id: 3, name: "Sócio proprietário" },
    { id: 4, name: "CEO" },
    { id: 5, name: "Gerente" },
    { id: 5, name: "Diretor" },
    { id: 5, name: "Coordenador" },
    { id: 5, name: "Supervisor" },
    { id: 5, name: "Outro" }
  ]
  const notas = [
    { id: 0, name: "Escolha o seu volume de nota" },
    { id: 1, name: "10 a 20 notas" },
    { id: 2, name: "21 a 50 notas" },
    { id: 3, name: "51 a 100 notas" },
    { id: 4, name: "101 a 500 notas" },
    { id: 5, name: "+500 notas" }
  ]
  const ramos = [
    { id: 0, name: "Escolha a sua área de atuação" },
    { id: 1, name: "Escritório Contábil" },
    { id: 2, name: "Empresa do Comércio" }
  ]
  const [nomeContato, setNomeContato] = useState('')
  const [nome, setNome] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [verificationPassword, setVerificationPassword] = useState('')
  const [numeroTelefone, setNumero] = useState('')
  const [cargo, setCargos] = useState(cargos[0])
  const [nota, setNota] = useState(notas[0])
  const [termos, setTermos] = useState(0)
  const [openModalPolitica, setOpenModalPolitica] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [ramo, setRamo] = useState(ramos[0])
  async function handleCadastrar(click) {
    // click()
    try {
      if (cargo.id === 0) {
        return toast(<ErrorToast error="Escolha seu cargo" />)
      }
      if (nota.id === 0) {
        return toast(<ErrorToast error="Escolha seu volume de notas" />)
      }
      if (ramo.id === 0) {
        return toast(<ErrorToast error="Escolha sua atuação" />)
      }
      if (numberIsValid(numeroTelefone)) {
        return toast(<ErrorToast error="Por favor, coloque um número válido" />)
      }

      if (numeroTelefone.length <= 10) {
        return toast(<ErrorToast error="Você precisa colocar um número de celular" />)
      }
      await apiNode.post("/integracao/cadastro", {
        nome: nome,
        // sobrenome: sobrenome,
        // estado: estado,
        ramo: ramo.name,
        contato: nomeContato,
        email: email,
        cargo: cargo.name,
        vol_nota: nota.name,
        celular: numeroTelefone,
        tag:"calculadora MVA"
      })
      localStorage.setItem('cadastro_reev', 'true')
      click()

    } catch (error) {
      console.log(error)
      toast(<ErrorToast error="Ops! Algo deu errado!" />)
    }
  }
  return (
    <Modal scrollable isOpen={props.open} >
      <ModalHeader className="bg-white"></ModalHeader>
      <p style={{ "fontSize": "1.6rem", "fontWeight":"500", "marginTop":"2rem" }} className="text-center ">Preencha os dados para usar gratuitamente a calculadora de MVA Ajustada.</p>
      <ScrollBar >
        <ModalBody style={{ "margin": "2rem" }}>
          <Form onSubmit={e => e.preventDefault()} className="d-flex form-account-details gap-2 flex-column">
            <Row>
              <Col >
                <Label >
                  Nome
                </Label>
                <Input type='text' placeholder='Rafael Oliveira' onChange={(e) => setNomeContato(e.target.value)} />
              </Col>
              <Col>
                <Label >
                  Celular (com o DDD)
                </Label>
                <Input onKeyPress={maskTelefone} maxLength="15" minLength="10" placeholder='9699191-0024' onChange={(e) => setNumero(e.target.value)} />
                {/* <Cleave className='form-control' onChange={(e) => setNumero(e.target.value)} placeholder='(96) 99191-0024' options={options} id='phone-number' /> */}
              </Col>
            </Row>
            <Row>
              <Col>
                <Label>
                  Empresa
                </Label>
                <Input type='text' placeholder='Tributei' onChange={(e) => setNome(e.target.value)} />
              </Col>
            </Row>
            <Row>
              <Col>
                <Label>
                  Seu Cargo
                </Label>
                <Select Array={cargos} selectedArray={cargo} setArray={setCargos} w="position-right-5 width-scroll-70" />
              </Col>
            </Row>
            <Row>
              <Col>
                <Label>
                  Você trabalha em:
                </Label>
                <Select Array={ramos} selectedArray={ramo} setArray={setRamo} w="position-right-5 width-scroll-70" />
              </Col>
            </Row>
            <Row>
              <Col>
                <Label className='text-label'>
                  Qual o volume de notas de compra você tem que calcular ICMS-ST ou DIFAL mensalmente ?
                </Label>
                <Select Array={notas} selectedArray={nota} setArray={setNota} w="position-right-5 width-scroll-70 " />
              </Col>
            </Row>
            <Row >
              <Col>
                <Label >
                  Email
                </Label>
                <Input
                  // onBlur={verifyEmail}
                  type='email'
                  className='email-cadastro'
                  // name={`email-${type}`}
                  // id={`email-${type}`}
                  placeholder='emai@gmail.com'
                  onChange={(e) => setEmail(e.target.value)}
                />
                <small className='d-none aviso-email text-danger'>O Email é inválido ou já está em uso no sistema.</small>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </ScrollBar>
      <div className='d-flex mb-4 justify-content-center'>
        <Button className="w-75" onClick={() => handleCadastrar(props.click)} color="primary">
          Continuar
        </Button>
      </div>
    </Modal>
  )
}